import { handleActions } from 'redux-actions';
import actions from 'state/direct-order-recurring/ui/actionCreators';
import initialState from 'state/direct-order-recurring/ui/initial.state';

const ui = handleActions(
  {
    [actions.setFetching]: (state, { payload: { isFetching } }) => ({
      ...state,
      isFetching,
    }),
    [actions.setSubmitting]: (state, { payload: { isSubmitting } }) => ({
      ...state,
      isSubmitting,
    }),
  },
  initialState
);

export default ui;
